import React from 'react'
import './index.css'
import { PageHeader } from 'antd'

const PageHeaderComponents = (props) => {
  const { onBack } = props
  const onClickBack = () => {
    if (props.disabled) return
    onBack()
  }
  return (
    <>
      <PageHeader
        className={props.className}
        title={props.title}
        onBack={onClickBack}
        backIcon={
          onBack ? (
            <i className={`header-arrow ${props.disabled ? 'disabled' : ''}`} />
          ) : (
            <></>
          )
        }
      />
    </>
  )
}

export default PageHeaderComponents
